import { ListItem, ListItemLabel, mergeOverrides, } from "@mezo-org/mezo-clay";
import React from "react";
const SHARED_LABEL_OVERRIDES = {
    LabelDescription: {
        style: {
            color: "#4B4B4B", // contentSecondary
        },
    },
};
export default function ListingItem(props) {
    const { icon: Icon, label, subLabel = "", value, subValue = "", overrides, } = props;
    return (React.createElement(ListItem, { artwork: Icon, 
        // eslint-disable-next-line react/no-unstable-nested-components
        endEnhancer: () => (React.createElement(ListItemLabel, { description: subValue, overrides: mergeOverrides({
                LabelRoot: {
                    style: {
                        textAlign: "right",
                    },
                },
            }, SHARED_LABEL_OVERRIDES) }, value)), overrides: mergeOverrides({
            Root: {
                style: {
                    backgroundColor: "transparent",
                },
            },
            Content: {
                style: {
                    border: 0,
                },
            },
        }, overrides) },
        React.createElement(ListItemLabel, { description: subLabel, overrides: SHARED_LABEL_OVERRIDES }, label)));
}
//# sourceMappingURL=ListingItem.js.map